import { jwtDecode } from 'jwt-decode';
import { tokenStorage } from './tokenStorage';

/**
 * Get the current user session from stored tokens
 * @returns {UserSession|null} User session or null if not authenticated
 */
export function getUserSession() {
    const accessToken = tokenStorage.getAccessToken();
    const idToken = tokenStorage.getIdToken();

    if (!accessToken || !idToken) {
        return null;
    }

    try {
        const decodedToken = jwtDecode(accessToken);

        return {
            user: {
                id: decodedToken.sub,
                sub: decodedToken.sub,
                email: decodedToken.email || '',
                name: decodedToken.name || '',
                given_name: decodedToken.given_name,
                family_name: decodedToken.family_name,
                email_verified: decodedToken.email_verified || false,
                preferred_username: decodedToken.preferred_username,
                phoneNumber: decodedToken.phoneNumber
            },
            access_token: accessToken,
            id_token: idToken
        };
    } catch (error) {
        console.error('Error decoding token:', error);
        return null;
    }
}

/**
 * Check if user is authenticated
 * @returns {boolean} True if user is authenticated and token is valid
 */
export function isAuthenticated() {
    const session = getUserSession();
    return session !== null && !tokenStorage.isTokenExpired();
}
